import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useState, useRef, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import roundSend from '@iconify/icons-ic/round-send';
import heartFill from '@iconify/icons-eva/heart-fill';
import shareFill from '@iconify/icons-eva/share-fill';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import messageSquareFill from '@iconify/icons-eva/message-square-fill';
import roundAddPhotoAlternate from '@iconify/icons-ic/round-add-photo-alternate';
// material
import {
  Box,
  Link,
  Card,
  Stack,
  Paper,
  Avatar,
  TextField,
  Typography,
  Button,
  CardHeader,
  IconButton,
  AvatarGroup,
  InputAdornment,
  FormControlLabel,
  CircularProgress
} from '@material-ui/core';
// utils
import { fDate } from '../../../../utils/formatTime';
import { fShortenNumber } from '../../../../utils/formatNumber';
// hooks
import useAuth from '../../../../hooks/useAuth';
//
import MyAvatar from '../../../MyAvatar';
import EmojiPicker from '../../../EmojiPicker';
import { MCheckbox } from '../../../@material-extend';
import Scrollbar from 'src/components/Scrollbar';

// ----------------------------------------------------------------------

ProfilePostCard.propTypes = {
  post: PropTypes.object
};


export default function ProfilePostCard({updates}) {
  const initialcount = 4
  const extraLoadCount = 4;
  const safeUpdates = updates || [];
  const [displayedComments, setDisplayedComments] = useState(safeUpdates.slice(0, initialcount))
  const [showAll, setShowAll] = useState(false);

  // Update displayedComments when updates prop changes
  useEffect(() => {
    if (updates && updates.length > 0) {
      setDisplayedComments(updates.slice(0, initialcount));
      setShowAll(false);
    }
  }, [updates]);

  const handleLoadMore = () => {
    const currentDisplayCount = displayedComments.length;
    const newDisplayCount = currentDisplayCount + extraLoadCount;
    const currentUpdates = updates || [];
    setDisplayedComments(currentUpdates.slice(0, newDisplayCount));
    setShowAll(newDisplayCount >= currentUpdates.length);
  };

  const handleLoadLess = () => {
    const currentDisplayCount = displayedComments.length;
    const currentUpdates = updates || [];
  
    if (currentDisplayCount > 3) {
      // Remove three comments at a time
      const newDisplayCount = currentDisplayCount - 3;
      setDisplayedComments(currentUpdates.slice(0, newDisplayCount));
      setShowAll(false);
    } else {
      // If only three comments are left, display the initial set of comments
      setDisplayedComments(currentUpdates.slice(0, initialcount));
      setShowAll(false);
    }
  };
  
  const ActivityComponent = ({ activity }) => {
    return (
      <Typography
        variant="body1"
        component="div"
        sx={{ '& strong': { fontWeight: 'bold' } }}
        dangerouslySetInnerHTML={{ __html: activity }}
      />
    );
  };

  return (
    <Card variant='outlined' sx={{ height: '450px',}}>
      <Scrollbar>
      <Stack spacing={3} sx={{ p: 3 }}>
        {updates === null || updates === undefined ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '300px' }}>
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <>
            <Stack spacing={1.5}>
              {displayedComments.map((comment) => (
            <Stack key={comment.id} direction="row" spacing={2}>
              <Avatar alt={comment.name} src={comment.profile_pic} />
              <Paper sx={{ p: 1.5, flexGrow: 1, bgcolor: 'background.neutral' }}>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  alignItems={{ sm: 'center' }}
                  justifyContent="space-between"
                  sx={{ mb: 0.5 }}
                >
                  <Typography variant="subtitle2" sx={{ color: 'primary.main' }}>{comment.name}</Typography>
                  <Typography variant="caption" sx={{ color: 'primary.main' }}>
                    {comment.timestamp}
                  </Typography>
                </Stack>
                <Typography variant="body2" sx={{ color:comment?.is_jobcost == 2 ? '#e60303ff' : '#ffffff' }}>
                  {/* {comment.activity} */}
                  <ActivityComponent activity={comment.activity} />
                </Typography>
              </Paper>
            </Stack>
          ))}
        </Stack>
            {(updates || []).length > initialcount  && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained" onClick={showAll ? handleLoadLess : handleLoadMore}>
                  {showAll ? 'Load Less' : 'Load More'}
                </Button>
              </Box>
            )}
          </>
        )}
      </Stack>
        </Scrollbar>
    </Card>
  );
}
